import styled, { keyframes } from 'styled-components';
import { THEME } from '@/common/styles/theme';

const hintFadeIn = keyframes`
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
`;

const chevronWave = keyframes`
	0%,
	100% {
		opacity: 0.18;
	}

	40%,
	60% {
		opacity: 1;
	}
`;

export const DiscoverSwipeHintRoot = styled.div`
	position: fixed;
	left: 50%;
	top: 50%;
	z-index: 22;
	display: none;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	pointer-events: none;
	transform: translate(-50%, -50%);
	animation: ${hintFadeIn} 0.45s ease-out;
	opacity: ${(props) => (props.$fadeOut ? 0 : 1)};
	transition: opacity 360ms ease;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		display: flex;
	}
`;

export const DiscoverSwipeHintChevrons = styled.div`
	color: rgba(255, 255, 255, 0.95);
	filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.55));

	svg {
		display: block;
		width: 26px;
		height: 34px;
	}

	.chevron {
		animation: ${chevronWave} 1.6s ease-in-out infinite;
	}

	.chevron-1 {
		animation-delay: 0s;
	}

	.chevron-2 {
		animation-delay: 0.18s;
	}

	.chevron-3 {
		animation-delay: 0.36s;
	}
`;

export const DiscoverSwipeHintLabel = styled.span`
	color: rgba(255, 255, 255, 0.92);
	font-family: ${THEME.fontApp};
	font-size: 0.88rem;
	font-weight: 600;
	line-height: 1.3;
	letter-spacing: 0.01em;
	text-align: center;
	text-shadow:
		0 2px 14px rgba(0, 0, 0, 0.72),
		0 0 24px rgba(0, 0, 0, 0.38);
`;
